import { z } from 'zod';
import { EmployeeSchema } from './EmployeeFormData';

// An emptied field means "leave it unchanged": only edited fields are sent.
const emptyAsUnchanged = <T extends z.ZodTypeAny>(schema: T) =>
  z.preprocess(
    (value) => (value === '' ? undefined : value),
    schema.optional(),
  );

export const UpdateEmployeeSchema = EmployeeSchema.extend({
  password: emptyAsUnchanged(EmployeeSchema.shape.password),
  // Older employees have no phone number.
  phoneNumber: emptyAsUnchanged(EmployeeSchema.shape.phoneNumber),
});

export type UpdateEmployeeFormData = z.infer<typeof UpdateEmployeeSchema>;
